// Shared "copy link" affordance used by v2 share rows on both the Event
// overview page and the Thankyou confirmation page. Wires every
// [data-share-copy] button under `root` to copy its data-share-url to the
// clipboard, flash a green check + "Link copied" tooltip for ~1.5s, then
// revert. If the host browser doesn't support navigator.clipboard the
// button is removed so we don't surface a non-working control.

const FEEDBACK_MS = 1500

const supportsClipboard = () =>
    typeof navigator !== 'undefined' &&
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === 'function'

export function initCopyShareButtons(root) {
    const scope = root || document
    const buttons = scope.querySelectorAll('[data-share-copy]')
    if (buttons.length === 0) return

    if (!supportsClipboard()) {
        buttons.forEach((btn) => btn.remove())
        return
    }

    buttons.forEach((btn) => {
        const url = btn.getAttribute('data-share-url') || ''
        btn.addEventListener('click', () => {
            navigator.clipboard.writeText(url).then(
                () => flashCopyFeedback(btn),
                () => {
                    // Clipboard write rejected (permission policy etc.) — fail
                    // silently; the user can still long-press / use the other
                    // share buttons.
                },
            )
        })
    })
}

function flashCopyFeedback(btn) {
    const linkIcon = btn.querySelector('[data-share-copy-icon]')
    const checkIcon = btn.querySelector('[data-share-copy-icon-success]')
    // Tooltip lives outside the <button> so the button's text-color flash
    // doesn't tint it — sibling under the same relative wrapper.
    const wrapper = btn.parentElement
    const tooltip = wrapper && wrapper.querySelector('[data-share-copy-feedback]')

    if (linkIcon) linkIcon.classList.add('hidden')
    if (checkIcon) checkIcon.classList.remove('hidden')
    if (tooltip) tooltip.classList.remove('hidden')

    window.setTimeout(() => {
        if (linkIcon) linkIcon.classList.remove('hidden')
        if (checkIcon) checkIcon.classList.add('hidden')
        if (tooltip) tooltip.classList.add('hidden')
    }, FEEDBACK_MS)
}
